/**
 * Recursive function to convert all key values within a JSON Object to lowerCase
 * @param   {Object} data The Object to be mutated
 * @returns {Object} data object with each string key value to lowerCase
 */
export const objectValuesToLowerCase = (data) => {
    // eslint-disable-next-line guard-for-in
    for (const prop in data) {
        if (typeof data[prop] === 'string') {
            data[prop] = data[prop].toLowerCase(); // eslint-disable-line no-param-reassign
        }
        if (typeof data[prop] === 'object') {
            objectValuesToLowerCase(data[prop]);
        }
    }
    return data;
};
